import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AbContrato } from "app/abstract/full-pages/contrato/contrato.abstract";

@Injectable({ providedIn: 'root' })
export class ContratoService extends AbContrato {

  constructor(http: HttpClient) {
    super(http);
  }

  public getAllContratosIntegrador() {
    return this.getAll("admin/contratos/all/integrador");
  }

  public getAllTipoContrato() {
    return this.get("admin/tipo_contratos/all");
  }

  public getAllContratosDTOIntegrador(integradorId) {
    return this.get(`admin/contratos/all/integrador/dto/${integradorId}`);
  }

  public migrarContratos(integradorId) {
    return this.post(`admin/contratos/migracao/tipo_licencas/${integradorId}`, {});
  }

}
